import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'

import {riskSurveyQueries} from '../../api'
import {useRiskSurveyTranslation} from '../useRiskSurveyTranslation'

type Variables = {
  reportId: string
  fileName: string
}

export const useExportReport = () => {
  const {t} = useRiskSurveyTranslation()

  return useMutation({
    mutationFn: async ({reportId}: Variables) => {
      return riskSurveyQueries.exportReport(reportId)
    },
    onSuccess: (blob, {fileName}) => {
      downloadFile(blob, fileName)
    },
    onError: () => {
      spawnErrorToast(t('export.error'))
    }
  })
}
